import { render, staticRenderFns } from "./Demandes.vue?vue&type=template&id=0daf11dc&"
import script from "./Demandes.vue?vue&type=script&lang=js&"
export * from "./Demandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports